(() => {
  if (customElements.get('lbn-christmas-fbt')) return;
  class ChristmasFbt extends HTMLElement {
    connectedCallback() {
      this.abort?.abort();
      this.abort = new AbortController();
      this.strings = JSON.parse(this.querySelector('[data-strings]').textContent);
      this.money = new Intl.NumberFormat(this.dataset.locale, { style: 'currency', currency: this.dataset.currency });
      this.rows = [...this.querySelectorAll('[data-row]')].map(el => ({
        el, variants: JSON.parse(el.querySelector('[data-variants]').textContent),
        size: el.querySelector('[data-size]'), check: el.querySelector('[data-include]')
      }));
      this.button = this.querySelector('[data-add]');
      const options = { signal: this.abort.signal };
      this.addEventListener('change', () => this.render(), options);
      window.addEventListener('stoq:loaded', () => this.render(), options);
      this.button.addEventListener('click', () => this.add(), options);
      this.render();
    }
    disconnectedCallback() { this.abort?.abort(); }
    selection(row) {
      const variant = row.variants.find(v => String(v.id) === row.size.value);
      if (!variant) return { note: '', valid: false };
      const api = window._RestockRocket;
      if (!api?.getSellingPlan || !api?.getLineItemProperties) return { variant, valid: false, note: this.strings.checking };
      const plan = api.getSellingPlan(variant.id) || api.getSellingPlan(String(variant.id));
      const preorder = plan && (plan.inventory_provider === 'always' || !variant.stock);
      const item = { id: variant.id, quantity: 1 };
      const unavailable = () => ({ variant, valid: false, note: this.strings.unavailable, fallback: true });
      if (!variant.available || (!variant.stock && !preorder) || (variant.requiresPlan && !preorder)) return unavailable();
      if (!preorder) return { variant, item, valid: true, note: '' };
      if (plan.inventory_provider === 'stoq') {
        const remaining = api.getPreorderAvailable?.(variant.id);
        if (Number.isFinite(remaining) && remaining < 1) return unavailable();
      }
      // Complex payment, acknowledgement and batch offers retain STOQ's own purchase flow.
      if (plan.payment_type !== 'full' || plan.pricing_type !== 'no_discount' || plan.batches_enabled || plan.require_preorder_acknowledgement || plan.allow_mixed_cart === false || plan.schedule_offer || plan.preorder_min_quantity > 1 || (plan.payment_options?.length || 0) > 1) return unavailable();
      const properties = api.getLineItemProperties(plan, variant.id, true);
      item.properties = Object.fromEntries(Object.entries(properties).filter(([key]) => !key.startsWith('attributes[')));
      if (plan.use_shopify_selling_plan) item.selling_plan = plan.shopify_selling_plan_id;
      const notes = Object.entries(item.properties).filter(([key]) => !key.startsWith('_') && key !== 'Purchase type').map(([key, value]) => `${key}: ${value}`);
      if (!notes.length) return unavailable();
      return { variant, item, valid: true, note: `${notes.join(' ')} ${this.strings.preorder}` };
    }
    render() {
      let total = 0, count = 0, valid = true;
      for (const row of this.rows) {
        let state;
        try { state = this.selection(row); } catch { state = { valid: false, note: this.strings.unavailable, fallback: true }; }
        row.state = state;
        row.el.querySelector('[data-note]').textContent = state.note;
        row.el.querySelector('[data-fallback]').hidden = !state.fallback;
        if (state.variant) {
          row.el.querySelector('[data-price]').textContent = this.money.format(state.variant.price / 100);
          const compare = row.el.querySelector('[data-compare]');
          compare.hidden = state.variant.compare <= state.variant.price;
          compare.textContent = this.money.format(state.variant.compare / 100);
        }
        if (row.check.checked) { count++; valid = valid && state.valid; total += state.variant?.price || 0; }
        row.check.disabled = Boolean(this.busy);
        row.size.disabled = Boolean(this.busy);
      }
      this.querySelector('[data-total]').textContent = this.money.format(total / 100);
      this.button.disabled = Boolean(this.busy) || !count || !valid;
      this.button.textContent = this.busy ? this.strings.adding : !count ? this.strings.choose_items : !valid ? this.strings.choose_sizes : `${this.strings.add_items} · ${this.money.format(total / 100)}`;
    }
    async add() {
      if (this.busy) return;
      this.render();
      if (this.button.disabled) return;
      const items = this.rows.filter(row => row.check.checked).map(row => row.state.item);
      this.busy = true;
      this.render();
      try {
        const response = await fetch(`${this.dataset.root}cart/add.js`, {
          method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items })
        });
        if (!response.ok) throw new Error('Cart rejected selection');
        window.location.assign(`${this.dataset.root}cart`);
      } catch {
        // An interrupted multi-add may have succeeded. Avoid duplicate retries.
        this.querySelector('[data-status]').textContent = this.strings.error;
        this.querySelector('[data-cart]').hidden = false;
        this.button.textContent = this.strings.view_cart;
      }
    }
  }
  customElements.define('lbn-christmas-fbt', ChristmasFbt);
})();
